import SayHelloCard from './SayHelloCard';

export default SayHelloCard;
